import React from "react";
import { useParams } from "react-router-dom";
import QuoteForm from "@/components/QuoteForm";
import { Check } from "lucide-react";

const CAMPAIGNS = {
  "auto-quote": { badge: "Limited-Time Auto Quote", title: "PAYING TOO MUCH FOR CAR INSURANCE?", type: "Auto" },
  "home-auto-bundle": { badge: "Home + Auto Bundle", title: "BUNDLE YOUR HOME & AUTO. SEE IF YOU CAN SAVE.", type: "Auto + Home Bundle" },
  "business-insurance": { badge: "Business Coverage", title: "PROTECT YOUR BUSINESS THE RIGHT WAY.", type: "Commercial / Business" },
  "life-insurance": { badge: "Life Insurance", title: "PROTECT THE PEOPLE WHO DEPEND ON YOU.", type: "Life Insurance" },
};

export default function Campaign() {
  const { slug } = useParams();
  const c = CAMPAIGNS[slug] || { badge: "Free Quote", title: "GET A FAST, FREE INSURANCE QUOTE.", type: null };
  return (
    <div className="min-h-screen bg-[#0B1E36] grain text-white flex items-center relative">
      <div className="max-w-6xl mx-auto px-5 py-16 grid lg:grid-cols-2 gap-12 items-center relative">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] font-bold mb-4">{c.badge}</p>
          <h1 className="font-display text-4xl lg:text-5xl font-black leading-tight">{c.title}</h1>
          <p className="mt-5 text-lg text-slate-200">Keystone Shield Insurance shops coverage that fits your needs and budget. No obligation.</p>
          <ul className="mt-6 space-y-2">
            {["Fast & Free", "No Obligation", "Local Pennsylvania Agency", "Personal Service"].map((t) => <li key={t} className="flex items-center gap-2 text-slate-200"><Check size={16} className="text-[#C5A059]" /> {t}</li>)}
          </ul>
        </div>
        <div><QuoteForm presetType={c.type} /></div>
      </div>
    </div>
  );
}
